import cartActionTypes from './cartTypes'

export const toggleCartHidden =()=>({
    type:cartActionTypes.TOGGLE_CART_HIDDEN
});
export const AddItems = item =>({
    type:cartActionTypes.ADD_ITEMS,
    payload:item
});

export const clearItemFromCart = item =>({
    type:cartActionTypes.CLEAR_ITEM_FROM_CART , 
    payload:item
});
 export const removeItem = item =>({
    type:cartActionTypes.REMOVE_ITEM,
    payload:item

 });
 export const emptyCart = () =>({
     type:cartActionTypes.EMPTY_CART
     
 })